/** Verification code length, guaranteed by the backend. */
export const VERIFICATION_CODE_LENGTH = 6;

const VERIFICATION_CODE_PATTERN = /^[a-zA-Z0-9]{6}$/;

export function isValidVerificationCode(code: string | null | undefined): boolean {
  return typeof code === 'string' && VERIFICATION_CODE_PATTERN.test(code);
}
